import React from 'react';
import { Prompt } from 'react-router-dom';

import http from 'api/http';
import { oilAPI } from 'api/requests';

import Select from 'Components/Select';
import ApplicationActions from 'Components/ApplicationActions';
import { Input } from 'Components/Input';
import NotificationManager from 'dom-managers/notification';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';

export default class FormulaCreate extends React.Component {
  constructor(props) {
    super(props);

    const currentYear = new Date().getFullYear();
    this.yearsList = [currentYear, currentYear + 1];

    this.state = {
      brandName: '',
      inputErrors: {},
      formulaBaseOilNumber: '',
      selectedYear: '',
      manufacturerAddress: '',
      description: '',
      isModalOpen: false,
      requestInProcess: false,
    };

    this.requiredFields = ['brandName', 'formulaBaseOilNumber', 'selectedYear', 'manufacturerAddress'];
    this.someDataWasInputted = false;
  }

  handleSelect = fieldName => input => {
    const {inputErrors} = this.state;
    let newInputErrors = inputErrors;
    const selectedItem = input;

    delete newInputErrors[fieldName];
    this.someDataWasInputted = true;
    this.setState({[fieldName]: selectedItem, inputErrors: newInputErrors});
  };

  handleInputChange = field => (value, error) => {
    const {inputErrors} = this.state;
    if (!error || error.ops) {
      delete inputErrors[field];
      this.someDataWasInputted = true;
      this.setState({[field]: value, inputErrors});
    }
  };

  handleBaseOilNumberInput = (value, error) => {
    const {inputErrors} = this.state;
    if (!error || error.ops) {
      delete inputErrors.formulaBaseOilNumber;
      this.someDataWasInputted = true;
      this.setState({formulaBaseOilNumber: value.toUpperCase(), inputErrors});
    }
  };

  _openModal = () => {
    this.setState({isModalOpen: true});
  };

  _closeModal = () => {
    this.setState({isModalOpen: false, requestInProcess: false});
  };

  validateForm = () => {
    const {inputErrors} = this.state;
    let newInputErrors = inputErrors;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    this.requiredFields.forEach(fieldName => {
      if (isEmptyString(this.state[fieldName]) || isEmptyArray(this.state[fieldName]) || isEmptyObject(this.state[fieldName])) newInputErrors[fieldName] = true;
    });

    return new Promise((resolve, reject) => {this.setState({inputErrors: newInputErrors}, () => {if (Object.keys(this.state.inputErrors).length) reject(); else resolve();});});
  };

  submitBrand = () => {
    const {brandName, formulaBaseOilNumber, selectedYear, manufacturerAddress, description} = this.state;
    const {user} = this.props;

    this.validateForm()
      .then(() => {
        let dataPayload = {
          name: brandName,
          description,
          year: selectedYear,
          formulaBaseOilNumber: formulaBaseOilNumber.trim(),
          manufacturerAddress: manufacturerAddress.value,
        };

        this.modalBody = 'Are you sure you want to submit this application?';
        this.modalConfirmAction = () => {
          this.setState({requestInProcess: true}, () => {
            http.post(oilAPI.submitBrand, dataPayload)
              .then(() => {
                NotificationManager.success(1, 'Your application was submitted successfully');
                this.someDataWasInputted = false;
                user.goToList(false, false);
              })
              .catch(error => {
                const errorMessage = error.response.data.message;
                if (errorMessage === 'Cannot submit/approve the application. The formulation on which it is based isn\'t Approved.' ||
                  errorMessage === 'Sorry there\'s no such Formulation.') {
                  const {inputErrors} = this.state;
                  inputErrors.formulaBaseOilNumber = true;
                  this.setState({inputErrors});
                }
              })
              .finally(() => {
                this.setState({requestInProcess: false});
                this._closeModal();
              });
          });
        };

        this._openModal();
      });
  };

  handleBackButtonClick = () => {
    const {user} = this.props;
    user.goToList();
  };

  blockUnconfirmedTransition = location => {
    const {user} = this.props;

    if (this.someDataWasInputted) {
      this.modalBody = 'You have unsaved data. Are you sure you want to exit application without saving?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this._closeModal();
        user.goTo(location);
      };
      this._openModal();
      return false;
    }
    return true;
  };

  render() {
    const {
      brandName, formulaBaseOilNumber, selectedYear, manufacturerAddress, description, inputErrors,
      isModalOpen, requestInProcess
    } = this.state;
    const {manufacturerAddresses} = this.props;

    return (
      <React.Fragment>
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper'>
            <section className='scene__scene-header detailsScene__scene-header'>
              <div className='go-back-to-list-header-button' onClick={this.handleBackButtonClick}>
                Back
              </div>
              <header>New Brand Application</header>
            </section>
            <section className='scene_section'>
              <header>General Info</header>
              <Input
                mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
                inputClassName='input__input-field_primary'
                label={'Brand Name *'}
                maxLength={250}
                value={brandName}
                error={inputErrors.brandName}
                onChange={this.handleInputChange('brandName')}
              />
              <Input
                mainWrapperClassName='input__main-wrapper_primary _margin_right_30'
                inputClassName='input__input-field_primary'
                label={'Base Oil Number *'}
                maxLength={250}
                value={formulaBaseOilNumber}
                error={inputErrors.formulaBaseOilNumber}
                onChange={this.handleBaseOilNumberInput}
              />
              <Select
                selectionList={this.yearsList}
                defaultItem={selectedYear}
                type='primary'
                inputClassName=''
                dropDownClassName=''
                label={'Year *'}
                error={inputErrors.selectedYear}
                handleSelect={this.handleSelect('selectedYear')}
              />
              <Input
                mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
                inputClassName='input__input-field_primary'
                label='Description'
                maxLength={250}
                placeholder={'Provide some description if necessary'}
                value={description}
                onChange={this.handleInputChange('description')}
              />
            </section>
            <section className='scene_section'>
              <header>Address</header>
              <Select
                selectionList={manufacturerAddresses}
                type='primary'
                mainWrapperClassName='_width_pc_100'
                defaultItem={manufacturerAddress}
                label='Select Address *'
                error={inputErrors.manufacturerAddress}
                itemNameIndicator='name'
                handleSelect={this.handleSelect('manufacturerAddress')}
              />
            </section>
            <ApplicationActions
              saveButtonLabel='Submit'
              saveButtonAction={this.submitBrand}
              cancelButtonLabel='Cancel'
              cancelButtonAction={this.handleBackButtonClick}
            />
          </section>
        </section>
        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this._closeModal}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_height_40 _width_160'
              onClick={this.modalConfirmAction}
            />
          </footer>
        </Modal>
        <Prompt message={this.blockUnconfirmedTransition} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Create/index.jsx